import { BACKEND_ORDERS_BASE_URL, BACKEND_ORDERS_WRITES_BASE_URL } from "@/services";
import Vue from "vue";
import {
  CancellationOrder,
  CancellationReason,
  Currency,
  Denomination,
  DenominationPack,
  Frequency,
  Order,
  OrderService,
  RawCancellationOrder,
  RawCancellationReason,
  RawCurrency,
  RawDenomination,
  RawDenominationPack,
  RawFrequency,
  RawOrders,
  RawSupply,
  UpdateOrderAssistance,
  UpdateOrderDeliveryChangeService,
  UpdateOrderDeliveryService,
  UpdateOrderPickupService,
  UpdateOrderSupplyService,
} from "@/orders";

export class OrderServiceImpl implements OrderService {
  async fetchOrders(map: Record<string, unknown>): Promise<Order[]> {
    const { data } = await Vue.$axios.post<RawOrders>(`${BACKEND_ORDERS_BASE_URL}/api/v1/orders/view`, map);
    return data.orders.map((value) => {
      return new Order(value);
    });
  }

  async saveOrderCreateAssistance(order: any): Promise<any> {
    await Vue.$axios.post<any>(`${BACKEND_ORDERS_WRITES_BASE_URL}/api/v1/orders/assistance-services`, order);
  }
  async saveOrderCreateSupply(order: any): Promise<any> {
    await Vue.$axios.post<any>(`${BACKEND_ORDERS_WRITES_BASE_URL}/api/v1/orders/supply-services `, order);
  }
  async saveOrderCreatePickup(order: any): Promise<any> {
    await Vue.$axios.post<any>(`${BACKEND_ORDERS_WRITES_BASE_URL}/api/v1/orders/pickup-services `, order);
  }

  async saveOrderCreateDelivery(order: any): Promise<any> {
    await Vue.$axios.post<any>(`${BACKEND_ORDERS_WRITES_BASE_URL}/api/v1/orders/delivery-services`, order);
  }

  async saveOrderCreateDeliveryChange(order: any): Promise<any> {
    await Vue.$axios.post<any>(`${BACKEND_ORDERS_WRITES_BASE_URL}/api/v1/orders/delivery-change-services`, order);
  }
  async fetchOrderCurrencies(country: string): Promise<Currency[]> {
    const { data } = await Vue.$axios.get<RawCurrency[]>(
      `${BACKEND_ORDERS_BASE_URL}/api/v1/currencies/country/${country}`
    );
    return data.map((value) => new Currency(value));
  }
  async fetchOrderDenominations(currency: string): Promise<Denomination[]> {
    const { data } = await Vue.$axios.get<RawDenomination[]>(
      `${BACKEND_ORDERS_BASE_URL}/api/v1/denominations/currency/${currency}`
    );
    return data.map((value) => new Denomination(value));
  }
  async fetchOrderDenominationPacks(country: string): Promise<DenominationPack[]> {
    const { data } = await Vue.$axios.get<RawDenominationPack[]>(
      `${BACKEND_ORDERS_BASE_URL}/api/v1/denomination-packs/country/${country}`
    );
    return data.map((value) => new DenominationPack(value));
  }
  async fetchSupplies(country: string): Promise<RawSupply[]> {
    const { data } = await Vue.$axios.get<RawSupply[]>(`${BACKEND_ORDERS_BASE_URL}/api/v1/supplies/country/${country}`);
    return data;
  }
  async fetchFrequencies(contractCode: string): Promise<Frequency> {
    const { data } = await Vue.$axios.get<RawFrequency>(
      `${BACKEND_ORDERS_BASE_URL}/api/v1/frequencies/contract/${contractCode}`
    );
    return data;
  }
  async fetchCancellationReasons(countryCode: string): Promise<CancellationReason[]> {
    const { data } = await Vue.$axios.get<RawCancellationReason[]>(
      `${BACKEND_ORDERS_BASE_URL}/api/v1/cancellation-reasons/country/${countryCode}`
    );
    return data.map((value) => new CancellationReason(value));
  }
  async patchOrderCancellation(order: CancellationOrder): Promise<CancellationOrder> {
    const { data } = await Vue.$axios.patch<RawCancellationOrder>(
      `${BACKEND_ORDERS_WRITES_BASE_URL}/api/v1/orders/order-cancellations`,
      order
    );
    return data;
  }
  async patchOrderAssistance(updateOrderAssistance: UpdateOrderAssistance): Promise<void> {
    await Vue.$axios.patch<void>(
      `${BACKEND_ORDERS_WRITES_BASE_URL}/api/v1/orders/${updateOrderAssistance.orderId}/assistance-services`,
      updateOrderAssistance
    );
  }
  async patchOrderSupply(updateOrderSupplyService: UpdateOrderSupplyService): Promise<void> {
    await Vue.$axios.patch<void>(
      `${BACKEND_ORDERS_WRITES_BASE_URL}/api/v1/orders/${updateOrderSupplyService.orderId}/supply-services`,
      updateOrderSupplyService
    );
  }
  async patchOrderPickup(updateOrderPickupService: UpdateOrderPickupService): Promise<void> {
    await Vue.$axios.patch<void>(
      `${BACKEND_ORDERS_WRITES_BASE_URL}/api/v1/orders/${updateOrderPickupService.orderId}/pickup-services`,
      updateOrderPickupService
    );
  }
  async patchOrderDelivery(updateOrderDeliveryService: UpdateOrderDeliveryService): Promise<void> {
    await Vue.$axios.patch<void>(
      `${BACKEND_ORDERS_WRITES_BASE_URL}/api/v1/orders/${updateOrderDeliveryService.orderId}/delivery-services`,
      updateOrderDeliveryService
    );
  }
  async patchOrderDeliveryChange(updateOrderDeliveryChangeService: UpdateOrderDeliveryChangeService): Promise<void> {
    await Vue.$axios.patch<void>(
      `${BACKEND_ORDERS_WRITES_BASE_URL}/api/v1/orders/${updateOrderDeliveryChangeService.orderId}/delivery-change-services`,
      updateOrderDeliveryChangeService
    );
  }
}
